import { fadeIn, slideUp } from "#lib/animations"
import { motion } from "framer-motion"
import { useTheme } from "./theme-provider"
import { Body, H1 } from "./ui/typography"

interface PageHeaderProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
}

export function PageHeader({ title, subtitle, actions }: PageHeaderProps) {
  const { resolvedTheme } = useTheme()
  const isDark = resolvedTheme === "dark"

  return (
    <motion.div initial="hidden" animate="visible" variants={fadeIn} className="mb-6 sm:mb-8">
      <div className="relative">
        <div
          className={`absolute inset-0 -z-10 rounded-2xl opacity-30 blur-3xl ${
            isDark
              ? "bg-gradient-to-br from-primary/20 via-primary/10 to-transparent"
              : "bg-gradient-to-br from-primary/10 via-primary/5 to-transparent"
          }`}
        />
        <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-6 pb-6 border-b border-border/50">
          <motion.div variants={slideUp}>
            <H1 className="text-4xl sm:text-5xl font-bold text-foreground mb-3 tracking-tight">
              {title}
            </H1>
            {subtitle && (
              <Body className="text-muted-foreground text-base sm:text-lg">{subtitle}</Body>
            )}
          </motion.div>
          {actions && (
            <motion.div variants={slideUp} className="flex sm:items-end flex-col gap-3">
              {actions}
            </motion.div>
          )}
        </div>
      </div>
    </motion.div>
  )
}
